const headers = {
  name: "Branches",
  navigate: {
    path: [
      {
        name: "Settings",
        path: "/app/settings",
      },
      {
        name: "Branches",
        path: "/app/settings/branches",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
